import React, {Component} from 'react'
import MaterialIcon, {colorPalette} from 'material-icons-react';
import HttpClient from "../../../utils/HttpClient/HttpClient";
import API_URL from "../../../utils/HttpClient/apiRest";
import TreeFormContent from "./TreeFormContent";
import {SCREEN_THRESHOLD} from "../../../global/constants";
import TreeFormDesktop from "./TreeFormDesktop";
import TreeFormMobile from "./TreeFormMobile";

export default class TreeForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            open: false,
            loaded: false,
            details: null
        }
        this.httpClient = new HttpClient(true);
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD
    }

    userClickAtLeastOnce;
    onOpenClick = () => {
        this.userClickAtLeastOnce = true;
        this.setState( { open : !this.state.open })
    }

    componentDidMount(){ }

    componentDidUpdate(prevProps) {
        let currentUser = this.props.selectedUser;
        if (prevProps.selectedUser !== currentUser) {
            if (!currentUser)return;

            this.setState({ loaded: false, details: null });
            this.httpClient.get(`oga/affiliate/file?nodeId=${currentUser.id}`)
                .then((response) => {
                    console.dir(response);
                    this.setState({ details: response.data, loaded: true });
                })
                .catch((error) => {
                    console.error("enter here error oga/affiliate/file", error);
                    this.setState({ loaded: true });
                });
        }

    }

    isPanelShowing;
    render() {
        let loaded = this.props.loaded;
        let loading = !this.state.loaded;
        let selectedUser = this.props.selectedUser;
        let empty = selectedUser ? selectedUser.nodeType.includes('EMPTY_') : false;
        let noUserSelected = !selectedUser || !selectedUser.name ;

        let hasInterested = false;
        let numberOfInterested = 0;
        if (selectedUser){
            numberOfInterested = selectedUser.interested.length;
            hasInterested = numberOfInterested !== 0;
        }

        let openClass;
        let overlayClass;
        if (this.userClickAtLeastOnce ){
            openClass = this.state.open ? "open-tree-form border tree-form-shadow" : "closed-tree-form";
            overlayClass = this.state.open ? "fade-show" : "fade-hide";
        }

        let containerClass;
        if (loaded){
            containerClass = noUserSelected && !hasInterested ? !this.isPanelShowing ? "opacity0" : "hide-tree-form" : this.isPanelShowing ? "opacity1" : "show-tree-form";
        }
        this.isPanelShowing = !((noUserSelected || empty) && !hasInterested);

        let interestedListOnly = noUserSelected && hasInterested && !this.state.details;

        let pulseClass = this.state.open ? !interestedListOnly ? "" : "bg-interested border-0" : interestedListOnly ?  "bg-interested border-0" : "pulse-button";
        let btnIcon = this.state.open ? "close" : interestedListOnly ?
            numberOfInterested > 9 ? 'filter_9_plus' :`filter_${numberOfInterested}`  : "perm_identity";


        let details = this.state.details;

        let forceClose = !hasInterested && empty;
        if (forceClose){
            this.state.open = false;
            openClass = "closed-tree-form";
        }

        return (
            <div>
                {
                    this.isDesktop ?
                        <TreeFormDesktop
                            loaded={loaded}
                            loading={loading}
                            selectedUser={selectedUser}
                            empty={empty}
                            containerClass={containerClass}
                            interestedListOnly={interestedListOnly}
                            btnIcon={btnIcon}
                            pulseClass={pulseClass}
                            details={details}
                            openClass={openClass}
                            overlayClass={overlayClass}
                            onOpenClick={() => this.onOpenClick()} /> :

                        <TreeFormMobile
                            loaded={loaded}
                            loading={loading}
                            selectedUser={selectedUser}
                            empty={empty}
                            containerClass={containerClass}
                            interestedListOnly={interestedListOnly}
                            btnIcon={btnIcon}
                            pulseClass={pulseClass}
                            details={details}
                            openClass={openClass}
                            overlayClass={overlayClass}
                            onOpenClick={() => this.onOpenClick()}/>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Tree/TreeForm/TreeForm.jsx